"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return breakpoints;
    }
});
var breakpoints = {
    base: "0px",
    sm: "414px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1440px",
    xxl: "1440px"
};
